"use strict";

/*==============================================================================*
*TRESTLE™ W004
*POPUP TOOL — NUTRIENT FINDER
*==============================================================================*/

window.TRESTLE_W004_TOOLS =
window.TRESTLE_W004_TOOLS || {};


window.TRESTLE_W004_TOOLS.nutrient_finder = {


/*==============================================================================*
*RENDER
*==============================================================================*/

render(){

    return `

    <div class="tr-w004-nutrient-tool">

        <div class="df-nutrient-finder">


            <p class="intro">

                Explore nutrients based on your interests or common wellness
                concerns. This tool is intended for educational purposes only
                and is not medical advice.

            </p>


            <!--==============================================================
            TABS
            ===============================================================-->

            <div class="df-tabs">

                <button
                type="button"
                class="df-tab-btn active"
                data-df-tab="nutrient">

                    Search by Nutrient

                </button>


                <button
                type="button"
                class="df-tab-btn"
                data-df-tab="concern">

                    Search by Concern

                </button>

            </div>


            <!--==============================================================
            SEARCH BY NUTRIENT
            ===============================================================-->

            <div
            class="df-tab-content active"
            data-df-content="nutrient">


                <select
                class="df-select"
                data-df-nutrient>

                    <option value="">
                        Select a Nutrient
                    </option>

                    <option value="vitd">
                        Vitamin D
                    </option>

                    <option value="calcium">
                        Calcium
                    </option>

                    <option value="magnesium">
                        Magnesium
                    </option>

                    <option value="iron">
                        Iron
                    </option>

                    <option value="b12">
                        Vitamin B12
                    </option>

                    <option value="fiber">
                        Fiber
                    </option>

                    <option value="protein">
                        Protein
                    </option>

                </select>


                <div
                class="df-result-box"
                data-df-nutrient-result
                hidden>
                </div>

            </div>


            <!--==============================================================
            SEARCH BY CONCERN
            ===============================================================-->

            <div
            class="df-tab-content"
            data-df-content="concern">


                <select
                class="df-select"
                data-df-concern>

                    <option value="">
                        Select a Concern
                    </option>

                    <option value="tired">
                        Feeling Tired
                    </option>

                    <option value="sleep">
                        Poor Sleep
                    </option>

                    <option value="cramps">
                        Muscle Cramps
                    </option>

                    <option value="energy">
                        Low Energy
                    </option>

                    <option value="bone">
                        Bone Health
                    </option>

                    <option value="digestion">
                        Digestive Concerns
                    </option>

                </select>


                <div
                class="df-result-box"
                data-df-concern-result
                hidden>
                </div>

            </div>


            <!--==============================================================
            DISCLAIMER
            ===============================================================-->

            <div class="df-disclaimer">

                Nutrient suggestions are educational references only.
                Individual nutritional needs may vary.

            </div>


        </div>

    </div>

    `;

},


/*==============================================================================*
*INIT
*==============================================================================*/

init(root){

    if(!root){

        return;

    }


    const tabButtons =

        root.querySelectorAll(

            "[data-df-tab]"

        );


    const tabContents =

        root.querySelectorAll(

            "[data-df-content]"

        );


    const nutrientSelect =

        root.querySelector(

            "[data-df-nutrient]"

        );


    const nutrientResult =

        root.querySelector(

            "[data-df-nutrient-result]"

        );


    const concernSelect =

        root.querySelector(

            "[data-df-concern]"

        );


    const concernResult =

        root.querySelector(

            "[data-df-concern-result]"

        );


/*==============================================================================*
*NUTRIENT CONTENT
*==============================================================================*/

    const nutrientContent = {

        vitd:`

            <h4>Vitamin D</h4>

            <ul>

                <li>Supports bone health</li>

                <li>Supports immune wellness</li>

                <li>Important during menopause</li>

            </ul>

        `,


        calcium:`

            <h4>Calcium</h4>

            <ul>

                <li>Supports strong bones</li>

                <li>Supports muscle function</li>

                <li>Important for healthy aging</li>

            </ul>

        `,


        magnesium:`

            <h4>Magnesium</h4>

            <ul>

                <li>Supports muscle function</li>

                <li>Supports relaxation and sleep</li>

                <li>Supports metabolic wellness</li>

            </ul>

        `,


        iron:`

            <h4>Iron</h4>

            <ul>

                <li>Supports oxygen transport</li>

                <li>Supports energy levels</li>

                <li>Important during reproductive years</li>

            </ul>

        `,


        b12:`

            <h4>Vitamin B12</h4>

            <ul>

                <li>Supports nerve health</li>

                <li>Supports energy production</li>

                <li>Supports healthy aging</li>

            </ul>

        `,


        fiber:`

            <h4>Fiber</h4>

            <ul>

                <li>Supports digestion</li>

                <li>Promotes fullness</li>

                <li>Supports balanced eating habits</li>

            </ul>

        `,


        protein:`

            <h4>Protein</h4>

            <ul>

                <li>Supports muscle maintenance</li>

                <li>Supports strength</li>

                <li>Important for healthy aging</li>

            </ul>

        `

    };


/*==============================================================================*
*CONCERN CONTENT
*==============================================================================*/

    const concernContent = {

        tired:`

            <h4>Feeling Tired</h4>

            <ul>

                <li>Iron</li>

                <li>Vitamin B12</li>

                <li>Magnesium</li>

            </ul>

        `,


        sleep:`

            <h4>Poor Sleep</h4>

            <ul>

                <li>Magnesium</li>

                <li>Vitamin D</li>

            </ul>

        `,


        cramps:`

            <h4>Muscle Cramps</h4>

            <ul>

                <li>Magnesium</li>

                <li>Potassium</li>

            </ul>

        `,


        energy:`

            <h4>Low Energy</h4>

            <ul>

                <li>Iron</li>

                <li>Vitamin B12</li>

                <li>Protein</li>

            </ul>

        `,


        bone:`

            <h4>Bone Health</h4>

            <ul>

                <li>Calcium</li>

                <li>Vitamin D</li>

                <li>Magnesium</li>

            </ul>

        `,


        digestion:`

            <h4>Digestive Concerns</h4>

            <ul>

                <li>Fiber</li>

                <li>Probiotics</li>

            </ul>

        `

    };


/*==============================================================================*
*TABS
*==============================================================================*/

    tabButtons.forEach(

        (button)=>{

            button.addEventListener(

                "click",

                ()=>{

                    const selectedTab =

                        button.dataset.dfTab;


                    tabButtons.forEach(

                        (item)=>{

                            item.classList.remove(

                                "active"

                            );

                        }

                    );


                    tabContents.forEach(

                        (item)=>{

                            item.classList.remove(

                                "active"

                            );

                        }

                    );


                    button.classList.add(

                        "active"

                    );


                    const selectedContent =

                        root.querySelector(

                            `[data-df-content="${selectedTab}"]`

                        );


                    if(selectedContent){

                        selectedContent.classList.add(

                            "active"

                        );

                    }

                }

            );

        }

    );


/*==============================================================================*
*NUTRIENT RESULT
*==============================================================================*/

    if(

        nutrientSelect &&
        nutrientResult

    ){

        nutrientSelect.addEventListener(

            "change",

            ()=>{

                const value =

                    nutrientSelect.value;


                if(

                    !value ||
                    !nutrientContent[value]

                ){

                    nutrientResult.hidden = true;

                    nutrientResult.innerHTML = "";

                    return;

                }


                nutrientResult.innerHTML =

                    nutrientContent[value];


                nutrientResult.hidden = false;

            }

        );

    }


/*==============================================================================*
*CONCERN RESULT
*==============================================================================*/

    if(

        concernSelect &&
        concernResult

    ){

        concernSelect.addEventListener(

            "change",

            ()=>{

                const value =

                    concernSelect.value;


                if(

                    !value ||
                    !concernContent[value]

                ){

                    concernResult.hidden = true;

                    concernResult.innerHTML = "";

                    return;

                }


                concernResult.innerHTML =

                    concernContent[value];


                concernResult.hidden = false;

            }

        );

    }

}

};